<template lang="pug">
.main-content
  //- .form-group
  //-   label.col-md-12 制御盤型式
  //-   .col-md-12
  //-     el-input(type='text',value='', v-model='controlPanelData.type')
  .form-group
    label.col-md-12 制御軸数:ロボット
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.controlAxis.robot')
  .form-group
    label.col-md-12 制御軸数:ワーク回転装置
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.controlAxis.turnDevice')
  .form-group
    label.col-md-12 制御軸数:塗料供給装置
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.controlAxis.maxSupplyDevice')
  .form-group
    label.col-md-12  制御方式
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.controlMethod')
  .form-group
    label.col-md-12  教示方式
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.teachingMethods[0]')
  .form-group
    label.col-md-12 ディスプレイ
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.display')
  .form-group
    label.col-md-12 データ記録方式
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.disk')
  .form-group
    label.col-md-12 外部保存方式
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.extStrage')
  .form-group
    label.col-md-12 制御盤重量
    .col-md-12
      el-input(type='text',value='', v-model='controlPanelData.controlPanelWeight')
  .form-group
    span.col-md-12 画像:正面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("frontImageFileAdd")'
    )
    .col-md-12
      el-table(:data='controlPanelData.frontImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage")') 
      input#frontImageFileAdd.hidden(type='file', @change='onFileAdd($event, "frontImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:側面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("sideImageFileAdd")'
    )
    .col-md-12
      el-table(:data='controlPanelData.sideImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage")') 
      input#sideImageFileAdd.hidden(type='file', @change='onFileAdd($event, "sideImage")', accept='image/*')
  .form-group
    span.col-md-12 画像:上面図
    el-button(
      type='primary',
      icon='el-icon-plus',
      size='mini',
      @click='onBtnFileAdd("topImageFileAdd")'
    )
    .col-md-12
      el-table(:data='controlPanelData.topImage')
        el-table-column(label='image', width='300')
          template(slot-scope='scope')
            img(:src='scope.row.image', height='128')
        el-table-column(property='name', label='name', width='200')
        el-table-column(label='', width='150')
          template(slot-scope='scope')
            el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage")') 
      input#topImageFileAdd.hidden(type='file', @change='onFileAdd($event, "topImage")', accept='image/*')

</template>


<script>
export default {
  name: 'ControlPanel',
  data () {
    return {
    }
  },
  props: {
    controlPanelData: Object
  },
  created () {
    if (!this.controlPanelData.frontImage) {
      this.controlPanelData.frontImage = []
    }
    if (!this.controlPanelData.sideImage) {
      this.controlPanelData.sideImage = []
    }
    if (!this.controlPanelData.topImage) {
      this.controlPanelData.topImage = []
    }
  },
  methods: {
    deleteImage (index, imageType) {
      let imageName = ''
      let imageObject
      if (imageType === 'frontImage') {
        imageName = this.controlPanelData.frontImage[index].name !== undefined ? this.controlPanelData.frontImage[index].name : '画像'
        imageObject = this.controlPanelData.frontImage
      } else if (imageType === 'sideImage') {
        imageName = this.controlPanelData.sideImage[index].name !== undefined ? this.controlPanelData.sideImage[index].name : '画像'
        imageObject = this.controlPanelData.sideImage
      } else if (imageType === 'topImage') {
        imageName = this.controlPanelData.topImage[index].name !== undefined ? this.controlPanelData.topImage[index].name : '画像'
        imageObject = this.controlPanelData.topImage
      }
      this.$confirm(imageName + 'を削除しますか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (idName) {
      document.getElementById(idName).click()
    },
    onFileAdd (event, objName) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.controlPanelData[objName].splice(0, 1)
          this.controlPanelData[objName].push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<style lang="scss", scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}
</style>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/ControlPanel.vue